import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json";
import translationZh from "./locales/zh/translation.json";
import translationZhTW from "./locales/zh-TW/translation.json";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: "en",

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      zh: {
        translations: translationZh,
      },
      "zh-TW": {
        translations: translationZhTW,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;